import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import {
    coreBasicApiUrlPrefix,
    coreSearchApiUrlPrefix,
    chemicalUserApiPrefix,
    discoveryApiUrlPrefix as discoveryBasicApiPrefix,
} from 'library-@/config/constants';
import { discoveryIds } from '../utils/dataFilter';
import { ANALYTICS_URI, HOME_SERVICE_URI } from 'library-@/config/apiConfig';
import { get } from 'lodash';
import qs from 'qs';

const getNewHistoryRecordsChannel = new RequestChannel(psHttp$);
export function getNewHistoryRecordsApi({
    page = 1,
    q,
    duration,
    tzOffset,
    start,
    end
}) {
    const currentLang = get(window, 'zPREFACE.lang');
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/history/search/list`,
        params: {
            page,
            q,
            duration,
            tzOffset,
            start,
            end
        },
        headers: {
            'X-Site-Lang': currentLang,
        },
        method: 'GET',
        transformCode: true,
    }).then(({ data }) => {
        return data || {};
    });
}

// const getHistoryRecordsChannel = new RequestChannel(psHttp$);
export function getHistoryRecordsApi({
    type,
    page = 1,
    q,
    duration,
    tzOffset,
    start,
    end
}) {
    const currentLang = get(window, 'zPREFACE.lang');
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/history/records`,
        params: {
            type,
            page,
            q,
            duration,
            tzOffset,
            start,
            end
        },
        headers: {
            'X-Site-Lang': currentLang,
        },
        method: 'GET',
        transformCode: true,
    }).then(data => {
        return data.data || {};
    });
}


export function exportHistoryRecordsApi({
    tzOffset,
    data
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/export/${tzOffset}`,
        method: 'POST',
        data: {
            data
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function convertQueryApi({ query }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/query`,
        method: 'POST',
        data: {
            query
        },
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function getOrignDocApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/origin/doc`,
        method: 'POST',
        data,
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}

export function writePatentHistroyApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history`,
        method: 'POST',
        data,
        headers: {
            'X-API-Version': '1.0'
        }
    });
}

/*
 discovery-history接口
*/
//search
// const getDiscoveryHistoryRecordsChannel = new RequestChannel(psHttp$);
export function getDiscoveryHistoryRecordsApi(params) {
    let limit = 20;
    let offset = (params.page - 1) * limit;
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${discoveryBasicApiPrefix}/2.0/search/history/search`,
        method: 'POST',
        data: {
            limit,
            offset,
            keyword: params.q,
            updated_at_from: params.start || '',
            updated_at_to: params.end || ''
        },
        cancelToken: params.cancelToken,
    }).then(data => {
        return data || {};
    });
}
//export
export function getDiscoveryHistoryExportApi(params) {
    let limit = 20;
    let offset = (params.page - 1) * limit;
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${discoveryBasicApiPrefix}/1.0/product/export/history/search`,
        method: 'POST',
        data: {
            limit,
            offset,
            created_at_from: params.start || '',
            created_at_to: params.end || ''
        },
        cancelToken: params.cancelToken,
    }).then(data => {
        return data || {};
    });
}

/*
 chemical-history接口 page接口
*/
// const getChemicalHistoryChannel = new RequestChannel(psHttp$);
export function getChemicalHistoryApi(params) {
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${chemicalUserApiPrefix}/history/page`,
        method: 'GET',
        params,
    }).then(data => {
        return data || {};
    });
}

/*
 chemical-history count接口
*/
const getChemicalHistoryCountChannel = new RequestChannel(psHttp$);
export function getChemicalHistoryCountApi(params) {
    return getChemicalHistoryCountChannel.requestAsPromise({
        url: `${chemicalUserApiPrefix}/history/count`,
        method: 'GET',
        params,
    }).then(data => {
        return data || {};
    });
}

/*
 通用导出接口
*/
export function exportHistory(params) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/excel`,
        method: 'POST',
        data: params,
    }).then(({ data }) => {
        return data || {};
    });
}

/**
 * 通过 inchi_key 获取 preview
 * @param {string} inchiKey - Inchi_key
 * @return {Promise}
 */
export function getPreview(inchiKey) {
    return psHttp({
        method: 'GET',
        url: `${chemicalUserApiPrefix}/chemical_data/preview/inchi_key/${inchiKey}`,
    });
}

/*
 analytics删除接口  传ids和type 删部分   不传ids 全身
*/
export function deleteAnalyticsHistoryApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/history/`,
        data,
        method: 'DELETE',
        transformCode: true,
    }).then(({ data }) => {
        return data.data || {};
    });
}
/*
 discovery 删除接口
*/

//导出删除全部
export function deleteAllDiscoveryExportHistoryApi() {
    return psHttp({
        url: `${discoveryBasicApiPrefix}/2.0/product/export/history/clear/all`,
        method: 'DELETE',
    });
}

//导出删除部分(id1,id2,id3)
export function deleteDiscoveryExportHistoryApi(params) {
    let ids = discoveryIds(params);
    return psHttp({
        url: `${discoveryBasicApiPrefix}/1.0/product/export/history/${ids}`,
        method: 'DELETE',
    });
}

//搜索删除全部
export function deleteAllDiscoverySearchHistoryApi() {
    return psHttp({
        url: `${discoveryBasicApiPrefix}/1.0/search/history`,
        method: 'DELETE',
    });
}

//搜索删除批量
export function deleteDiscoverySearchHistoryApi(params) {
    let ids = discoveryIds(params);
    return psHttp({
        url: `${discoveryBasicApiPrefix}/2.0/search/history/${ids}`,
        method: 'DELETE',
    });
}

/*
 chemical 删除接口 直接传history_ids 和 delete_all 和 history_type
*/
export async function deleteChemicalHistoryApi(data) {
    return psHttp({
        url: `${chemicalUserApiPrefix}/history/`,
        data,
        method: 'DELETE',
    }).then(res => {
        return res;
    });
}

export async function searchTransferQueryApi({ query, search_from, search_mode }, httpConfig = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/transfer-query`,
        method: 'POST',
        data: {
            query,
            search_from,
            search_mode
        },
        transformCode: true,
        ...httpConfig
    }).then(({ data }) => {
        let res = data.data || {};
        delete res.stem;
        let url = `${ANALYTICS_URI}/search/result?${qs.stringify(res)}`;
        res.redirectUrl = url;
        return res;
    });
}

// login接口
// 获取history列表
export function getLoginHistoryRecordsApi({
    page = 1,
    q,
    duration,
    tzOffset,
    start,
    end
}) {
    const currentLang = get(window, 'zPREFACE.lang');
    return getNewHistoryRecordsChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/history/login/records`,
        params: {
            page,
            q,
            duration,
            tzOffset,
            start,
            end
        },
        headers: {
            'X-Site-Lang': currentLang,
        },
        method: 'GET',
        transformCode: true,
    }).then(data => {
        return data.data || {};
    });
}

// 初始化
export const pageInit = () => {
    const initURL = `${HOME_SERVICE_URI}/home/history/init`;
    return psHttp({ url: initURL });
};
